

        <!-- header area start -->
        <div class="header2">
            <div class="">
                <div class="topHeader">
                    <div class="logo">
                        <img src="../../../../assets/img/autotrader.png" alt="">

                        <i class="fa-solid fa-bars"></i>
                    </div>
                    <div class="search">
                        <input type="text" class="form-control">
                        <button class="btn" type="button"><i class="fa-solid fa-magnifying-glass"></i> Search</button>
                    </div>

                    <div class="login">
                        <ul class="log">
                            <li>
                                <div class="dropdown">
                                    <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                      English
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                      <li><a class="dropdown-item" [routerLink]="['/'+ handle]">Arabic</a></li>
                                      <li><a class="dropdown-item" [routerLink]="['/'+ handle]">French</a></li>
                                      <li><a class="dropdown-item" [routerLink]="['/'+ handle]">German</a></li>
                                    </ul>
                                  </div>
                            </li>

                            <li>
                                <a [routerLink]="['/'+ handle]">
                                    <img src=".//img/Vector.png" alt="">
                                    Login
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bottomHeader">
                    <ul>
                        <li><a  [routerLink]="['/'+ handle]"><i class="fa-solid fa-house"></i> Home</a></li>
                        <li><a [routerLink]="['/'+ handle]">Used Cars</a></li>
                        <li><a [routerLink]="['/'+ handle]">Compare</a></li>
                        <li><a [routerLink]="['/'+ handle]">Deals</a></li>
                    </ul>

                    <a [routerLink]="['/'+ handle]">
                        <button class="btn" type="button">Sell Your Car</button>
                    </a>
                    
                </div>
            </div>
        </div>
        <!-- header area end -->


        <!-- detail section start -->
        <app-dealer-info></app-dealer-info>

        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <img src="./img/logo-1.png" class="logo" alt="">
                        <p class="mb-4">CarSpot Automotive Car Classified WordPress Theme is flexible and powerful Car Classified wordpress Theme for your all automotive & car listing business needs.</p>
                        <ul class="social">
                            <li><a><i class="fa-brands fa-facebook-f"></i> </a></li>
                            <li><a><i class="fa-brands fa-twitter"></i> </a></li>
                            <li><a><i class="fa-brands fa-linkedin-in"></i> </a></li>
                            <li><a><i class="fa-brands fa-google-plus-g"></i></a></li>
                            <li><a><i class="fa-brands fa-youtube"></i> </a></li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h5>Quick Links</h5>

                        <div class="d-flex">
                            <ul>
                                <li><a>Home</a></li>
                                <li><a>About Us</a></li>
                                <li><a>Comparison</a></li>
                                <li><a>Expert Reviews</a></li>
                            </ul>
    
                            <ul>
                                <li><a>Elements</a></li>
                                <li><a>Checkout</a></li>
                                <li><a>Packages</a></li>
                                <li><a>Contact Us</a></li>
                            </ul>
                        </div>
                     
                    </div>
                    <div class="col-md-3">
                        <h5>Get Our Apps</h5>
                        <a class="google">
                            <img src="./img/google.png" alt="">
                        </a>
                        <a class="apple">
                            <img src="./img/apple.png" alt="">
                        </a>
                    </div>

                    <div class="col-12 text-center">
                        <p class="copyright">© Copyright 2022  </p>
                    </div>
                </div>
            </div>
        </footer>
    